// src/chevron-right.tsx
import { jsx } from "react/jsx-runtime";
var ChevronRightIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: "1em",
    role: "presentation",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    viewBox: "0 0 24 24",
    width: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m9 18 6-6-6-6" })
  }
);

export {
  ChevronRightIcon
};
